module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('bee', {
    attrs: {
      "clientId": _vm.tenant.beeClientId,
      "clientSecret": _vm.tenant.beeClientSecret
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6cb73b00!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/templates/TemplateEditor.vue
// module id = 741
// module chunks = 1